import { moneyToNumber } from "../../../../../utils/formatter";
import { Obligaciones } from "../../../../../utils/obligations";
import moment from "moment";

export const ObligationTorpedo = (transaction) => {
  if (!transaction) return "";

  if (["santander"].includes(transaction.bankId)) {
    if (transaction.shortcut) return transaction.shortcut;

    if (transaction.description) {
      if (transaction.description.toLowerCase().includes("remunerac"))
        return "sueldos";
      if (transaction.description.toLowerCase().includes("talana"))
        return "sueldos";
      if (
        transaction.description.toLowerCase().includes("cheque") &&
        transaction.type == "SPEND"
      )
        return "cheques_por_pagar";
      if (
        transaction.description.toLowerCase().includes("cheque") &&
        transaction.type !== "SPEND"
      )
        return "cheques_por_cobrar";
      if (transaction.description.toLowerCase().includes("s.i.i."))
        return "iva_debito_credito";
      if (transaction.description.toLowerCase().includes("previred"))
        return "leyes_sociales";
      if (transaction.description.toLowerCase().includes("rescate"))
        return "fondos_mutuos";
      if (transaction.description.toLowerCase().includes("fondos mutuos"))
        return "fondos_mutuos";
      if (transaction.description.toLowerCase().includes("fondo mutuo"))
        return "fondos_mutuos";
      if (transaction.description.toLowerCase().includes("t. crédito"))
        return "tarjeta_de_credito";
      if (transaction.description.toLowerCase().includes("seg. fraude"))
        return "seguros";
      if (transaction.description.toLowerCase().includes("t.g.r"))
        return "iva_debito_credito";
    }
  }

  return "";
};

export const parseObligation = (variables, companyId, contacts, type, editData) => {
  const isReceived = variables.isReceived;
  const area = Obligaciones.find(
    (f) => f.subAreas && f.subAreas.find((g) => g.type == variables.type)
  );
  const subArea = area && area.subAreas ? area.subAreas.find((g) => g.type == variables.type) : null;

  const parseMoney = (money) => {
    return parseFloat(money)
    if (!money) return 0;
    const result = parseFloat(
      String(money || "")
        .replace(/[^0-9,]/g, '')
        .replace(/,/g, ".")
    )

    if (result === null) {
      return parseInt(String(money).replace(/[^0-9]/g, ''))
    }

    return result

  };

  const manage = (route) => {
    if (!variables.issuerId) return "";
    const contact = contacts.find((f) => f && (f.id == variables.issuerId || f._id == variables.issuerId));
    if (route == "name") return contact?.name;
    if (route == "rut") return contact?.rut;
  }

  const name = variables.issuerId == "add" ? variables.name : manage("name");
  const rut = variables.issuerId == "add" ? variables.rut : manage("rut");

  let OBLIGATION = {};
  let invoiceDetails;

  // Preparar detalle actualizado cuando se edita y existe un detalle previo
  // Nota: unit_price y total_price se actualizarán más abajo una vez calculado localValue
  const updatedDetail = editData?.meta?.detail
    ? editData.meta.detail.map((detailItem, index) => {
        const { __typename, ...cleanDetail } = detailItem || {};
        return index === 0
          ? { ...cleanDetail, description: variables.description }
          : cleanDetail
      })
    : undefined;

  if (variables.type === "invoice" && false) {
    OBLIGATION = {
      documentType: "OBLIGATION",
      amount: parseMoney(variables.amount),
      documentDate: new Date(moment(variables.documentDate, "YYYY-MM-DD")),
      companyId,
      currencyType: variables.currency || "CLP",
      cashflowAreaId: variables.cashflowAreaId,
      isManual: true,
      fieldKey: variables.fieldKey || editData?.fieldKey,
      recurringId: editData?.recurringId,
      dueDate: editData?.dueDate,
      meta: {
        date: new Date(moment(variables.documentDate, "YYYY-MM-DD")),
        documentDate: new Date(moment(variables.documentDate, "YYYY-MM-DD")),
        desdeDate: variables?.desdeDate ? new Date(moment(variables.desdeDate, "YYYY-MM-DD"))
          : new Date(moment().format("YYYY-MM-DD")),
        hastaDate: variables?.hastaDate ? new Date(moment(variables.hastaDate, "YYYY-MM-DD"))
          : new Date(moment().format("YYYY-MM-DD")),
        tipo: variables?.tipo ? variables.tipo || editData?.meta.tipo : 'unico',
        repeat: variables.repeat,
        number: variables.documentId,
        amount: parseMoney(variables.amount),
        currency: variables.currency || "CLP",
        remaining: variables.originalAmount
          ? parseMoney(variables.originalAmount)
          : parseMoney(variables.amount),
        isPaid: type == "efectivo" ? true : false,
        originalAmount: variables.originalAmount
          ? parseMoney(variables.originalAmount)
          : parseMoney(variables.amount),
        taxRate: 0,
        issuerId: isReceived ? rut : "",
        issuerName: isReceived ? name : "",
        receiverId: isReceived ? "" : rut,
        receiverName: isReceived ? "" : name,
        paymentDate: null,
        isReceived,
        rate: parseMoney(variables.rate || 0),
        referenceNumber: variables.referenceNumber
          ? variables.referenceNumber
          : "",
        description: variables.description,
        nominaStatus: editData?.meta?.nominaStatus,
        detail: (updatedDetail !== undefined && updatedDetail !== null) ? updatedDetail : (variables.detail ? variables.detail : invoiceDetails),
        isMassive: variables.isMassive
      },
    };
  } else if (variables.type === 'traspaso_entre_cuentas' && editData && false) {
    OBLIGATION = {
      documentType: "OBLIGATION",
      amount: variables.originalAmount
        ? parseMoney(variables.originalAmount)
        : parseMoney(variables.amount),
      documentDate: new Date(moment(variables.documentDate, "YYYY-MM-DD")),
      companyId,
      currencyType: variables.currency || "CLP",
      isManual: true,
      isHidden: variables.type === "efectivo",
      cashflowAreaId: variables.cashflowAreaId,
      fieldKey: variables.fieldKey || editData?.fieldKey,
      recurringId: editData?.recurringId,
      dueDate: editData?.dueDate,
      meta: {
        date: new Date(moment(variables.documentDate, "YYYY-MM-DD")),
        documentDate: new Date(moment(variables.documentDate, "YYYY-MM-DD")),
        desdeDate: variables?.desdeDate ? new Date(moment(variables.desdeDate, "YYYY-MM-DD"))
          : new Date(moment().format("YYYY-MM-DD")),
        hastaDate: variables?.hastaDate ? new Date(moment(variables.hastaDate, "YYYY-MM-DD"))
          : new Date(moment().format("YYYY-MM-DD")),
        tipo: variables?.tipo ? variables.tipo || editData?.meta.tipo : 'unico',
        repeat: variables.repeat,
        number: variables.documentId,
        amount: parseMoney(variables.originalAmount ?? variables.amount),
        currency: variables.currency || "CLP",
        remaining: 0,
        isPaid: true,
        originalAmount: parseMoney(variables.originalAmount ?? variables.amount),
        taxRate: 0,
        issuerId: isReceived ? rut : "",
        issuerName: isReceived ? name : "",
        receiverId: isReceived ? "" : rut,
        receiverName: isReceived ? "" : name,
        paymentDate: null,
        isReceived,
        rate: parseMoney(variables.rate || 0),
        referenceNumber: variables.referenceNumber
          ? variables.referenceNumber
          : "",
        description: variables.description,
        detail: updatedDetail,
        isMassive: variables.isMassive
      },
    };
  } else {
    // Determinar si tenemos una moneda distinta de CLP con tipo de cambio
    const originalCurrency = variables.currency || "CLP";
    const rate = parseMoney(variables.rate || 0);
    const rawOriginalAmount = parseMoney(variables.originalAmount ?? variables.amount);
    const isNonCLP = originalCurrency !== 'CLP' && rate > 0;
    
    // Si no es CLP: los montos en meta (amount, remaining, originalAmount) deben estar en CLP
    const localValue = isNonCLP ? Math.round(rate * rawOriginalAmount) : rawOriginalAmount;
    
    // Actualizar precios del detalle para que coincidan con el monto actual (pueden estar desactualizados de una edición o moneda anterior)
    if (updatedDetail && updatedDetail.length > 0) {
      updatedDetail[0].unit_price = localValue;
      updatedDetail[0].total_price = localValue;
    }
    
    // Armar datos de exchange para monedas distintas de CLP
    let exchangeData = undefined;
    if (isNonCLP) {
      exchangeData = {
        originalAmount: rawOriginalAmount,        // Monto en moneda original (UF, USD, etc.)
        originalCurrency: originalCurrency,       // Moneda original
        localAmount: localValue,                  // Monto en CLP
        localCurrency: 'CLP',
        exchangeRate: rate,                       // Tipo de cambio
        exchangeDate: moment(variables.documentDate, "YYYY-MM-DD").toISOString(),
      };
    }
    
    OBLIGATION = {
      documentType: "OBLIGATION",
      amount: localValue,
      documentDate: new Date(moment(variables.documentDate, "YYYY-MM-DD")),
      companyId,
      currencyType: isNonCLP ? 'CLP' : originalCurrency,
      isManual: true,
      isHidden: false,
      cashflowAreaId: variables.cashflowAreaId,
      fieldKey: variables.fieldKey || editData?.fieldKey,
      recurringId: editData?.recurringId,
      // Al editar: preservar la fecha de vencimiento existente (puede haber sido postergada).
      // Solo usar documentDate como dueDate al crear una nueva obligación.
      dueDate: editData?.dueDate
        ? new Date(moment(editData.dueDate).set('hour', 15).toDate())
        : (variables.documentDate ? new Date(moment(variables.documentDate, "YYYY-MM-DD")) : undefined),
      localAmount: isNonCLP ? localValue : (rawOriginalAmount * rate),
      meta: {
        date: new Date(moment(variables.documentDate, "YYYY-MM-DD")),
        documentDate: new Date(moment(variables.documentDate, "YYYY-MM-DD")),
        desdeDate: variables?.desdeDate ? new Date(moment(variables.desdeDate, "YYYY-MM-DD"))
          : new Date(moment().format("YYYY-MM-DD")),
        hastaDate: variables?.hastaDate ? new Date(moment(variables.hastaDate, "YYYY-MM-DD"))
          : new Date(moment().format("YYYY-MM-DD")),
        tipo: variables?.tipo ? variables.tipo || editData?.meta.tipo : 'unico',
        repeat: variables.repeat,
        number: variables.documentId,
        amount: localValue,
        currency: isNonCLP ? 'CLP' : originalCurrency,
        remaining: type == "efectivo" ? 0 : localValue,
        isPaid: type == "efectivo" ? true : false,
        originalAmount: localValue,
        taxRate: 0,
        issuerId: isReceived ? rut : "",
        issuerName: isReceived ? name : "",
        receiverId: isReceived ? "" : rut,
        receiverName: isReceived ? "" : name,
        paymentDate: null,
        isReceived,
        rate: isNonCLP ? 1 : rate,
        referenceNumber: variables.referenceNumber
          ? variables.referenceNumber
          : "",
        description: variables.description,
        nominaStatus: editData?.meta?.nominaStatus,
        detail: updatedDetail,
        isMassive: variables.isMassive,
        exchange: exchangeData || null,  // Explícitamente null cuando es CLP para limpiar exchange obsoleto
      },
    };
  }

  // Asegurar que siempre tengamos family, familyLabel, type, y typeLabel
  // Cuando se edita: priorizar editData.meta (valores originales)
  // Si el tipo cambió o no hay editData: usar subArea
  // Si no hay ninguno: usar valores por defecto
  
  // Verificar si el tipo de obligación cambió
  const typeChanged = editData?.meta?.type && editData.meta.type !== variables.type;
  
  // Determinar qué campos usar
  let metaFields = {};
  
  if (editData?.meta && !typeChanged) {
    // Edición sin cambio de tipo: preservar valores originales
    metaFields = {
      family: editData.meta.family || editData.meta.familyKey || subArea?.family || '',
      familyLabel: editData.meta.familyLabel || subArea?.familyLabel || '',
      type: editData.meta.type || editData.meta.typeKey || subArea?.type || variables.type || '',
      typeLabel: editData.meta.typeLabel || subArea?.typeLabel || '',
    };
  } else if (subArea) {
    // Tipo cambió o no hay editData: usar subArea
    metaFields = {
      family: subArea.family || editData?.meta?.family || editData?.meta?.familyKey || '',
      familyLabel: subArea.familyLabel || editData?.meta?.familyLabel || '',
      type: subArea.type || editData?.meta?.type || editData?.meta?.typeKey || variables.type || '',
      typeLabel: subArea.typeLabel || editData?.meta?.typeLabel || '',
    };
  } else {
    // Fallback: usar editData.meta o valores por defecto
    metaFields = {
      family: editData?.meta?.family || editData?.meta?.familyKey || '',
      familyLabel: editData?.meta?.familyLabel || '',
      type: editData?.meta?.type || editData?.meta?.typeKey || variables.type || '',
      typeLabel: editData?.meta?.typeLabel || '',
    };
  }

  // Construir el resultado final asegurando que siempre tengamos los campos requeridos
  let finalMeta = { ...OBLIGATION.meta };
  
  if (subArea && (!editData || typeChanged)) {
    // Si subArea existe y el tipo cambió o no hay editData, usar subArea
    finalMeta = { ...finalMeta, ...subArea };
  }
  
  // Siempre asegurar que los campos requeridos estén presentes
  finalMeta = {
    ...finalMeta,
    family: finalMeta.family || metaFields.family,
    familyLabel: finalMeta.familyLabel || metaFields.familyLabel,
    type: finalMeta.type || metaFields.type,
    typeLabel: finalMeta.typeLabel || metaFields.typeLabel,
  };
  
  const result = { ...OBLIGATION, meta: finalMeta };
  
  return result
};

export const DocumentTypes = [
  { label: "Invoices", id: "invoice", value: "invoice" },
  { label: "Nota de Cobro", id: "nota_cobro", value: "nota_cobro" },
  { label: "Rendiciones", id: "rendiciones", value: "rendiciones" },
  { label: "Contratos (Arriendos)", id: "contratos", value: "contratos" },
  { label: "Finiquitos", id: "finiquito", value: "finiquito" },
  { label: "Cheques", id: "cheques", value: "cheques" },
  { label: "Pago por un tercero", id: "pago_tercero", value: "pago_tercero" },
];

export const currencies = [
  {
    key: "CLP",
    id: "CLP",
    label: "CLP",
  },
  {
    key: "USD",
    id: "USD",
    label: "USD",
  },
  {
    key: "EUR",
    id: "EUR",
    label: "EUR",
  },
  // {
  //   key: "UTM",
  //   id: "UTM",
  //   label: "UTM",
  // },
];

export const ObligationFamilies = [
  {
    type: "family",
    id: "facturas",
    label: "Facturas",
    children: [
      { type: "children", id: "factura_venta", label: "Factura de Venta" },
      { type: "children", id: "factura_exenta", label: "Factura Exenta" },
      { type: "children", id: "nota_credito", label: "Nota de Crédito" },
      {
        type: "children",
        id: "nota_credito_exenta",
        label: "Nota de Crédito Exenta",
      },
      { type: "children", id: "nota_debito", label: "Nota de Débito" },
      {
        type: "children",
        id: "nota_debito_exenta",
        label: "Nota de Débito Exenta",
      },
      {
        type: "children",
        id: "factura_exportacion",
        label: "Factura de Exportación",
      },
      {
        type: "children",
        id: "nota_debito_exportacion",
        label: "Nota de Débito de Exportación",
      },
      {
        type: "children",
        id: "nota_credito_exportacion",
        label: "Nota de Crédito de Exportación",
      },
      {
        type: "children",
        id: "declaracion_ingreso_(din)",
        label: "Declaración de Ingreso (DIN)",
      },
      {
        type: "children",
        id: "liquidacion-factura",
        label: "Liquidación-Factura",
      },
      { type: "children", id: "factura_compra", label: "Factura de Compra" },
    ],
  },
  {
    type: "family",
    id: "boleta_venta_o_servicios",
    label: "Boleta de Venta o Servicios",
    children: [
      { type: "children", id: "boleta_venta", label: "Boleta de Venta" },
      {
        type: "children",
        id: "boleta_venta_exenta",
        label: "Boleta de Venta Exenta",
      },
    ],
  },
  {
    type: "family",
    id: "internacional",
    label: "Internacional",
    children: [{ type: "children", id: "invoice", label: "Invoice" }],
  },
  {
    type: "family",
    id: "boleta_honorarios",
    label: "Boleta de Honorarios",
    children: [
      {
        type: "children",
        id: "boleta_honorarios",
        label: "Boleta de Honorarios",
      },
      { type: "children", id: "boleta_terceros", label: "Boleta de Terceros" },
      {
        type: "children",
        id: "boleta_honorarios_director",
        label: "Boleta Honorarios Director",
      },
    ],
  },
  {
    type: "family",
    id: "rendiciones",
    label: "Rendiciones",
    children: [
      { type: "children", id: "fondo_por_rendir", label: "Fondo por Rendir" },
      {
        type: "children",
        id: "fondo_recibido_por_rendir",
        label: "Fondo Recibido por Rendir",
      },
      { type: "children", id: "gasto_anticipado", label: "Gasto Anticipado" },
      {
        type: "children",
        id: "gasto_anticipado_transbank_credito",
        label: "Gasto Anticipado Transbank Crédito",
      },
      {
        type: "children",
        id: "gasto_anticipado_transbank_debito",
        label: "Gasto Anticipado Transbank Débito",
      },
      // { type: 'children', id: 'gasto_anticipado_cumplo', label: 'Gasto Anticipado Cumplo'},
      {
        type: "children",
        id: "anticipo_cliente/proveedor",
        label: "Anticipo Cliente/Proveedor",
      },
      {
        type: "children",
        id: "regularizacion_bancaria",
        label: "Regularización Bancaria",
      },
    ],
  },
  {
    type: "family",
    id: "creditos",
    label: "Créditos",
    children: [
      { type: "children", id: "capital", label: "Capital" },
      { type: "children", id: "interes", label: "Interés" },
      { type: "children", id: "interes_por_mora", label: "Interés por mora" },
      {
        type: "children",
        id: "impuesto_timbre_y_estampilla",
        label: "Impuesto timbre y estampilla",
      },
    ],
  },
  {
    type: "family",
    id: "cuenta_corriente_mercantil",
    label: "Cuenta Corriente Mercantil",
    children: [{ type: "children", id: "prestamo", label: "Préstamo" }],
  },
  {
    type: "family",
    id: "sueldos",
    label: "Sueldos",
    children: [
      { type: "children", id: "afp_inp", label: "AFP / INP" },
      { type: "children", id: "apv", label: "APV" },
      { type: "children", id: "isapre_fonasa", label: "Isapre / Fonasa" },
      { type: "children", id: "afc", label: "AFC" },
      {
        type: "children",
        id: "mutuales_seguridad",
        label: "Mutuales de Seguridad",
      },
      {
        type: "children",
        id: "impuesto_2ª_categoria",
        label: "Impuesto 2ª Categoría",
      },
      { type: "children", id: "otros_descuentos", label: "Otros Descuentos" },
      { type: "children", id: "anticipos", label: "Anticipos" },
      { type: "children", id: "sueldos", label: "Sueldos" },
      { type: "children", id: "aguinaldos", label: "Aguinaldos" },
      { type: "children", id: "finiquitos", label: "Finiquitos" },
      {
        type: "children",
        id: "caja_compensacion",
        label: "Caja de Compensación",
      },
    ],
  },
  {
    type: "family",
    id: "obligacion_tributaria",
    label: "Obligación Tributaria",
    children: [
      {
        type: "children",
        id: "pago_provisional_mensual",
        label: "Pago Provisional Mensual",
      },
      {
        type: "children",
        id: "iva_debito_credito",
        label: "IVA Débito / Crédito",
      },
      {
        type: "children",
        id: "remanente_credito_fiscal",
        label: "Remanente Crédito Fiscal",
      },
      {
        type: "children",
        id: "iva_debito_credito_exportador",
        label: "IVA Débito / Crédito Exportador",
      },
      {
        type: "children",
        id: "retencion_extranjeros",
        label: "Retención Extranjeros",
      },
      {
        type: "children",
        id: "retencion_boletas_servicio",
        label: "Retención Boletas de Servicio",
      },
      {
        type: "children",
        id: "patentes_municipales",
        label: "Patentes municipales",
      },
      { type: "children", id: "contribuciones", label: "Contribuciones" },
      {
        type: "children",
        id: "impuesto_a_la_renta",
        label: "Impuesto a la renta",
      },
    ],
  },
  {
    type: "family",
    id: "otros_pagos/cobros",
    label: "Otros Pagos/Cobros",
    children: [
      {
        type: "children",
        id: "contrato_compra/venta",
        label: "Contrato Compra/Venta",
      },
      { type: "children", id: "contrato_arriendo", label: "Contrato Arriendo" },
      { type: "children", id: "membresia", label: "Membresía" },
      {
        type: "children",
        id: "contrato_cuentas_en_participacion",
        label: "Contrato de Cuentas en Participación",
      },
      {
        type: "children",
        id: "garantias_entregadas",
        label: "Garantías Entregadas",
      },
      { type: "children", id: "leasing", label: "Leasing" },
      { type: "children", id: "nota_cobro", label: "Nota de Cobro" },
      { type: "children", id: "juicio", label: "Juicio" },
      // { type: 'children', id: 'corfo', label: 'Corfo'},
      // { type: 'children', id: 'sercotec', label: 'Sercotec'},
      { type: "children", id: "seguros", label: "Seguros" },
    ],
  },
  {
    type: "family",
    id: "inversiones_financieras",
    label: "Inversiones Financieras",
    children: [
      { type: "children", id: "deposito_a_plazo", label: "Depósito a Plazo" },
      { type: "children", id: "fondo_mutuo", label: "Fondo Mútuo" },
      { type: "children", id: "acciones", label: "Acciones" },
      { type: "children", id: "fondo_inversion", label: "Fondo de Inversión" },
      { type: "children", id: "bonos", label: "Bonos" },
      {
        type: "children",
        id: "otros_instrumentos_financieros",
        label: "Otros Instrumentos Financieros",
      },
      { type: "children", id: "mayor/menor_valor", label: "Mayor/Menor Valor" },
    ],
  },
  {
    type: "family",
    id: "aumentos_disminucion_capital",
    label: "Aumentos / Disminución de Capital",
    children: [
      {
        type: "children",
        id: "suscripcion_derechos_acciones",
        label: "Suscripción de Derechos / Acciones",
      },
      {
        type: "children",
        id: "disminucion_capital",
        label: "Disminución de Capital",
      },
    ],
  },
  {
    type: "family",
    id: "reparto_utilidad",
    label: "Reparto de Utilidad",
    children: [
      {
        type: "children",
        id: "dividendos_retiro_definitivo",
        label: "Dividendos / Retiro Definitivo",
      },
      {
        type: "children",
        id: "dividendos_retiro_provisorio",
        label: "Dividendos / Retiro Provisorio",
      },
    ],
  },
  {
    type: "family",
    id: "otros_pagos_mensuales",
    label: "Otros Pagos Mensuales",
    children: [
      {
        type: "children",
        id: "contrato_arriendo",
        label: "Contrato de Arriendo",
      },
      {
        type: "children",
        id: "comprobante_gastos_comunes",
        label: "Comprobante Gastos Comunes",
      },
      { type: "children", id: "donacion", label: "Donación" },
      { type: "children", id: "premios", label: "Premios" },
      {
        type: "children",
        id: "multas_a_beneficio_fiscal",
        label: "Multas a Beneficio Fiscal",
      },
      {
        type: "children",
        id: "permiso_circulacion",
        label: "Permiso de Circulación",
      },
      {
        type: "children",
        id: "pago_tarjeta_credito",
        label: "Pago Tarjeta de Crédito",
      },
      { type: "children", id: "cheque", label: "Cheque" },
      {
        type: "children",
        id: "pago_por_un_tercero",
        label: "Pago por un Tercero",
      },
      { type: "children", id: "efectivo", label: "Efectivo" },
      { type: "children", id: "factoring", label: "Factoring" },
      {
        type: "children",
        id: "sobregiro_cuenta_corriente",
        label: "Sobregiro Cuenta Corriente",
      },
      {
        type: "children",
        id: "impuestos_financieros",
        label: "Impuestos Financieros",
      },
      {
        type: "children",
        id: "intereses_financieros",
        label: "Intereses Financieros",
      },
      { type: "children", id: "propinas", label: "Propinas" },
      { type: "children", id: "movilizacion", label: "Movilización" },
      {
        type: "children",
        id: "reunion_negocios",
        label: "Reunión de Negocios",
      },
      { type: "children", id: "gastos_varios", label: "Gastos Varios" },
      { type: "children", id: "gasto_cliente", label: "Gasto de Cliente" },
      { type: "children", id: "tipo_cambio", label: "Tipo Cambio" },
      { type: "children", id: "diferencia_de_pago", label: "Diferencia de Pago" },
      { type: "children", id: "diferenciadetipodecambio", label: "Diferencia de Tipo de Cambio" },
      { type: "children", id: "diferencia_de_tipo_de_cambio", label: "Diferencia de Tipo de Cambio" },
      { type: "children", id: "otros_ingresos", label: "Otros Ingresos" },
    ],
  },
  {
    type: "family",
    id: "proyeccion",
    label: "Proyección",
    children: [
      {
        type: "children",
        id: "proyeccion",
        label: "Proyección",
      },
    ],
  },
  //  { type: 'family',
  //    id: 'creditos_cumplo',
  //    label: 'Créditos Cumplo',
  //    children: [
  //         { type: 'children', id: 'cuota_credito_cumplo', label: 'Cuota Crédito Cumplo'},
  //    ] },
];

export const IndexedObligationFamilies = (family) => {
  const indexed = ObligationFamilies.reduce((acc, el) => {
    if (!acc) acc = {};
    acc[el.id] = el;

    return acc;
  }, {});

  if (family) return indexed[family] ? indexed[family] : indexed["facturas"];
  return indexed["facturas"];
};

export const parseCrearObligacionInput = (target) => {
  const { name, value } = target;
  if (["amount", "originalAmount", "remaining"].includes(name))
    return moneyToNumber(value);
  if (["rate"].includes(name)) {
    const cleanValue = value.replace(/,/g, ".").replace(/[^0-9.]/g, "");
    return cleanValue / 100;
  }

  return value;
};

export const findFamilyLabel = (value) => {
  return ObligationFamilies?.find((f) => f?.id == value)?.label;
};

export const findTypeLabel = (family, type) => {
  return ObligationFamilies?.find((f) => f?.id == family)?.children?.find(
    (g) => g?.id == type
  )?.label;
};

export const typeIncomeExpense = [
  { label: "Ingresos", id: "income", value: "income" },
  { label: "Egresos", id: "expense", value: "expense" },
];
